import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as OnboardingAddPatients } from 'assets/OnboardingAddPatients.svg';
import Theme from 'theme';


function AddPatientsStep() {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' mb={4.5}>
      <Box sx={{ width: '100%', mb: 4.5 }}>
        <OnboardingAddPatients width='100%' height='100%' />
      </Box>
      <Typography variant='h6' fontWeight={500} sx={{ mb: 2 }} color={Theme.custom.colors.lightTextPrimary}>
        Add patients
      </Typography>
      <Typography sx={{ fontSize: 16, color: Theme.custom.colors.lightTextPrimary, textAlign: 'center' }}>
        You can get started by clicking the “ADD PATIENTS” button at the top of the screen.
        <br />
        All you need is the
        {' '}
        <b>
          patient’s name
        </b>
        {' '}
        and
        {' '}
        <b>
          mobile phone number.
        </b>
      </Typography>
    </Box>
  );
}

export default AddPatientsStep;
